import { logger } from '@parrot-software/observability';

import type { ISubscriptionEventsApiPort } from '@subscriptions/application/ports';
import type { SubscriptionEventViewDto } from '@subscriptions/application/dtos';
import { extractErrorAttributes } from '@subscriptions/application/utils';

const eventsLog = logger.forDomain('SUB', { subdomain: 'billing' });

/**
 * Use case for listing collection-status events (`GET /v1/events`).
 * SubscriptionEvent is a DTO-only type — the port returns the list of events
 * already mapped to view DTOs (cutoff date formatted, subscriptions count derived).
 *
 * @param port - Subscription events API port
 * @returns Use case executor
 */
export const listSubscriptionEventsUseCase = (port: ISubscriptionEventsApiPort) => {
  const execute = async (): Promise<SubscriptionEventViewDto[]> => {
    try {
      const events = await port.list();
      eventsLog.info('listSubscriptionEvents', {
        eventsCount: events.length,
        eventsList: events.map((eventDto) => eventDto.event).join(','),
      });
      return events;
    } catch (error) {
      eventsLog.error('listSubscriptionEvents', extractErrorAttributes(error));
      throw error;
    }
  };

  return { execute };
};
